function buildBranchQueue() {
const a  = state.answers;
const s  = state.scores;
const q  = [];
const v7 = a.v7 || [];
const isSport = v7.includes('sport_herstel') || v7.includes('sport_perf');
const isPreventief = v7.includes('preventief') || v7.includes('longevity');
if (['laag','uitgeput'].includes(a.v4) || v7.includes('energie')) q.push('v8','v9');
if (['slecht','probleem'].includes(a.v5) || v7.includes('slaap')) q.push('v10','v11','v11b');
if (['hoog','constant'].includes(a.v6) || v7.includes('stress')) q.push('v12','v13','v14');
if (v7.includes('pijn')) q.push('v15','v16','v17');
if (isSport) q.push('v18','v18b','v19','v20','v21');
if (v7.includes('afslanken')) q.push('v22','v22b','v22c','v22d');
if (v7.includes('beauty')) q.push('v23','v23b','v23c');
if (v7.includes('spijsvertering')) q.push('v24','v24b','v24c');
if (v7.includes('immuunsysteem') || v7.includes('preventief')) q.push('v25','v25b');
if (a.v1==='vrouw' && (
v7.includes('stress') || v7.includes('afslanken') ||
['45-60','60+'].includes(a.v2) || s.hormonen>=2
)) q.push('v26');
if (isPreventief) q.push('vprev1','vprev2');
q.push('v27','v28','v29','email');
return q;
}
function startQuiz() {
document.getElementById('intro-screen').style.display = 'none';
document.getElementById('quiz-screen').style.display = 'flex';
state.queue = ['v1','v2','v4','v5','v6','v7'];
state.currentIndex = 0;
renderQuestion();
}
function getFilteredOptions(q) {
const gender = state.answers.v1;
return q.options.filter(opt => !opt.onlyFor || opt.onlyFor === gender);
}
function renderQuestion() {
const qId  = state.queue[state.currentIndex];
const q    = Q[qId];
const cont = document.getElementById('question-container');
const total = state.queue.length;
const cur   = state.currentIndex + 1;
document.getElementById('progress-fill').style.width = ((cur/total)*100)+'%';
document.getElementById('progress-label').textContent = cur+' / '+total;
document.getElementById('back-btn').style.visibility = state.currentIndex===0?'hidden':'visible';
const opts = q.options ? getFilteredOptions(q) : [];
let html = '<div class="fade-in">';
html += '<p class="q-step">'+(q.phase||'')+'</p>';
html += '<h2 class="q-text">'+q.text+'</h2>';
if (q.sub) html += '<p class="q-sub">'+q.sub+'</p>';
if (q.type==='single') {
html += '<div class="options-list">';
opts.forEach((opt,i) => {
const rawIdx = q.options.indexOf(opt);
const sel = state.answers[qId]===opt.value?'selected':'';
html += '<button class="option-btn '+sel+'" onclick="selectSingle(\''+qId+'\','+rawIdx+')">';
if (opt.sub) {
html += '<span class="opt-label">'+opt.text+'</span><span class="opt-sub">'+opt.sub+'</span>';
} else { html += opt.text; }
html += '</button>';
});
html += '</div>';
} else if (q.type==='multi') {
const selected = state.answers[qId]||[];
const isGoals  = q.id==='v7';
html += '<p class="multi-hint">'+(isGoals?'Kies maximaal '+q.max+' onderwerpen.':'Selecteer alles wat op jou van toepassing is.')+'</p>';
html += '<div class="options-list">';
opts.forEach((opt,i) => {
const rawIdx = q.options.indexOf(opt);
const sel = selected.includes(opt.value)?'selected':'';
html += '<button class="option-btn '+sel+'" onclick="selectMulti(\''+qId+'\','+rawIdx+')">';
html += opt.text;
html += '</button>';
});
html += '</div>';
} else if (q.type==='email') {
html += '<div class="email-card">';
html += '<label>Jouw naam</label>';
html += '<input type="text" id="inp-name" placeholder="Voornaam" value="'+(state.answers.email_name||'')+'" oninput="updateNextBtn()">';
html += '<label>E-mailadres</label>';
html += '<input type="email" id="inp-email" placeholder="jouw@email.nl" value="'+(state.answers.email_addr||'')+'" oninput="updateNextBtn()">';
html += '<div class="checkbox-row"><input type="checkbox" id="inp-newsletter" '+(state.answers.newsletter?'checked':'')+' onchange="updateNextBtn()"><span>Ja, ik wil tips en nieuws van Frozen Cryo ontvangen.</span></div>';
html += '</div>';
}
html += '</div>';
cont.innerHTML = html;
updateNextBtn();
}
function selectSingle(qId, rawIdx) {
const q   = Q[qId];
const opt = q.options[rawIdx];
if (state.answers[qId]) {
const prev = q.options.find(o=>o.value===state.answers[qId]);
if (prev&&prev.scores) Object.entries(prev.scores).forEach(([k,v])=>{state.scores[k]=Math.max(0,state.scores[k]-v);});
}
state.answers[qId] = opt.value;
if (opt.scores) Object.entries(opt.scores).forEach(([k,v])=>{state.scores[k]=(state.scores[k]||0)+v;});
document.querySelectorAll('.option-btn').forEach((b,j)=>{
const filtered = getFilteredOptions(q);
const visibleIdx = filtered.findIndex(o=>o.value===opt.value);
b.classList.toggle('selected', j===visibleIdx);
});
updateNextBtn();
}
function selectMulti(qId, rawIdx) {
const q   = Q[qId];
const opt = q.options[rawIdx];
let sel   = [...(state.answers[qId]||[])];
if (sel.includes(opt.value)) {
sel = sel.filter(v=>v!==opt.value);
if (opt.scores) Object.entries(opt.scores).forEach(([k,v])=>{state.scores[k]=Math.max(0,state.scores[k]-v);});
} else {
if (q.id==='v7' && sel.length>=q.max) return;
sel.push(opt.value);
if (opt.scores) Object.entries(opt.scores).forEach(([k,v])=>{state.scores[k]=(state.scores[k]||0)+v;});
}
state.answers[qId] = sel;
const filtered = getFilteredOptions(q);
document.querySelectorAll('.option-btn').forEach((b,j)=>{
b.classList.toggle('selected', j<filtered.length && sel.includes(filtered[j].value));
});
updateNextBtn();
}
function updateNextBtn() {
const qId = state.queue[state.currentIndex];
const q   = Q[qId];
let ok = false;
if (q.type==='single')      ok = !!state.answers[qId];
else if (q.type==='multi')  ok = (state.answers[qId]||[]).length>0;
else if (q.type==='email')  {
const n=document.getElementById('inp-name');
const e=document.getElementById('inp-email');
ok = n&&e&&n.value.trim().length>0&&e.value.includes('@');
}
document.getElementById('btn-next').disabled = !ok;
}
function goNext() {
const qId = state.queue[state.currentIndex];
const q   = Q[qId];
if (q.type==='email') {
state.answers.email_name = document.getElementById('inp-name').value.trim();
state.answers.email_addr = document.getElementById('inp-email').value.trim();
state.answers.newsletter = document.getElementById('inp-newsletter').checked;
showResults(); return;
}
if (qId==='v2' && state.answers.v1==='vrouw' && ['45-60','60+'].includes(state.answers.v2)) {
if (!state.queue.includes('v3')) state.queue.splice(state.currentIndex+1,0,'v3');
}
if (qId==='v7') {
state.queue = state.queue.slice(0,state.currentIndex+1).concat(buildBranchQueue());
}
state.currentIndex++;
if (state.currentIndex>=state.queue.length){showResults();return;}
renderQuestion();
}
function goBack() {
if (state.currentIndex===0) return;
state.currentIndex--;
renderQuestion();
}
function computeProfile() {
const s = state.scores;
const a = state.answers;
const v7 = a.v7||[];
const otherHigh = Object.entries(s).filter(([k,v])=>k!=='lever'&&v>=4).length;
if (s.lever>=6&&otherHigh>=2) return 'leverklant';
const sorted = Object.entries(s).filter(([k])=>k!=='lever').sort((a,b)=>b[1]-a[1]);
const primary = sorted[0]?.[0];
const secondary = sorted[1]?.[0];
const topScore = sorted[0]?.[1]||0;
const isPreventief = v7.includes('preventief')||v7.includes('longevity');
if (topScore<=2 || isPreventief) return 'vitale_investeerder';
if (primary==='stress'&&topScore>=5)               return 'overlever';
if (primary==='energie'&&secondary==='stress')     return 'overlever';
if (primary==='sport')                             return 'atleet';
if (primary==='pijn')                              return 'pijndrager';
if (primary==='slaap')                             return 'slechte_slaper';
if (primary==='beauty')                            return 'beauty_builder';
if (primary==='immuunsysteem')                     return 'gevoelige';
if (primary==='hormonen')                          return 'hormonale';
if (primary==='spijsvertering')                    return 'darmklopper';
if (primary==='afslanken')                         return 'metabolische';
if (primary==='energie')                           return 'uitgebluste';
return 'vitale_investeerder';
}
function computeSupplements() {
const s = state.scores;
const a = state.answers;
const v7 = a.v7||[];
const supps = [];
supps.push(a.v1==='vrouw'
? {step:'Stap 1 — Dagelijkse basis', name:'Smart Vitamins for Her',
desc:'Jouw dagelijkse fundering — afgestemd op vrouwelijke noden inclusief ijzer, folaat en DHA. Ondersteunt energie, concentratie en immuunsysteem.'}
: {step:'Stap 1 — Dagelijkse basis', name:'Smart Vitamins for Him',
desc:'Jouw dagelijkse fundering — afgestemd op mannelijke noden. Ondersteunt energie, concentratie en immuunsysteem.'});
supps.push({step:'Stap 2 — Lever & ontgifting', name:'Detox Boost',
desc:'LIPOGLUTATHOX™ — glutathion, NAC, artisjok en mariadistel. Ondersteunt alle drie de detoxfases van de lever en verbetert de opname van alle andere supplementen.'});
const step3 = [];
if (s.lever>=6) step3.push({name:'Liverboost Forte',
desc:'PROANTRODIA™ — intensieve leverondersteuning naast Detox Boost. Stimuleert leverherstel en vetmetabolisme.',
note:'Combineer altijd met Detox Boost voor dagelijkse leverondersteuning.'});
const isPrev = v7.includes('preventief')||v7.includes('longevity');
const hasOtherGoals = v7.filter(g=>!['preventief','longevity'].includes(g)).length>0;
if (isPrev && !hasOtherGoals) {
const prevFocus = a.vprev1;
if (prevFocus==='huid_prev'||prevFocus==='alles') {
step3.push({name:'Smart Collagen Shot',
desc:'Keraboost™ voor huid, haar én nagels. Collageenverlies start al op je 25e — dit is huidonderhoud voor de lange termijn. Cryo stimuleert collageenproductie van buitenaf, dit supplement levert de bouwstenen van binnenuit.'});
}
if (prevFocus==='huid_prev'&&step3.length<2) {
step3.push({name:'Glow Goddess',
desc:'Beschermt huidcellen tegen oxidatieve stres — de dieperliggende oorzaak van veroudering. Samen met de Smart Collagen Shot de sterkste combinatie voor huidonderhoud op de lange termijn.'});
}
if ((prevFocus==='immuun_prev'||prevFocus==='hart')&&step3.length<2) {
step3.push({name:'Immuniq-10 Boost',
desc:'Preventieve ondersteuning voor energie én preventief weerstand. Juist als er nog geen klachten zijn maar je het systeem sterk wil houden voor de lange termijn.'});
}
if (prevFocus==='alles'&&step3.length<2) {
step3.push({name:'Immuniq-10 Boost',
desc:'Brede preventieve ondersteuning voor energie en weerstand. Samen met de Smart Collagen Shot dek je veroudering en weerstand tegelijk af.'});
}
if (prevFocus==='cognitief'&&step3.length<2) {
step3.push({name:'Mental Boost',
desc:'Saffraan en Lion\'s Mane ondersteunen cognitieve helderheid, focus en emotionele balans op de lange termijn.'});
}
if (prevFocus==='gewrichten'&&step3.length<2) {
step3.push({name:'J-Magneflex II',
desc:'Collageen type II en glucosamine als preventieve bouwstenen voor je gewrichten. Investeer nu in mobiliteit later.'});
}
if (step3.length===0) {
step3.push({name:'Immuniq-10 Boost',
desc:'Brede preventieve ondersteuning voor energie en weerstand. Een sterk startpunt voor langetermijn gezondheid.'});
}
} else {
const sorted = Object.entries(s).filter(([k])=>k!=='lever').sort((a,b)=>b[1]-a[1]);
for (const [domain, score] of sorted) {
if (step3.length>=2) break;
if (score<2) break;
let supp = null;
if (domain==='slaap'&&!step3.find(x=>x.name==='Deep Sleep')) {
supp = {name:'Deep Sleep',
desc:"Helpt je lichaam 's avonds tot rust te komen. Geen slaapmiddel — een formulering die je overgang naar diepe slaap ondersteunt. Combineer met een avondsessie cryo voor maximaal effect."};
} else if (domain==='stress'&&!step3.find(x=>x.name==='Mental Boost')) {
supp = {name:'Mental Boost',
desc:'Saffraan en Lion\'s Mane ondersteunen emotionele balans en focus. Cryo verlaagt cortisol van buitenaf — Mental Boost ondersteunt het zenuwstelsel van binnenuit.'};
} else if (domain==='pijn') {
const pType = a.v17;
const isChronisch = ['artrose','reuma','fibromyalgie','rug'].includes(pType)&&a.v16==='dagelijks';
if (isChronisch&&!step3.find(x=>x.name==='J-Magneflex II')) {
supp = {name:'J-Magneflex II',
desc:'Collageen type II en glucosamine als bouwstenen voor je gewrichten. Voor structurele en chronische klachten. Cryo vermindert de ontsteking — J-Magneflex II bouwt van binnenuit.'};
} else if (!step3.find(x=>x.name==='Ultra Move')) {
supp = {name:'Ultra Move',
desc:'95% curcumine met zwarte peper en PEA. Een krachtige natuurlijke ontstekingsremmer. Cryo werkt op de ontsteking van buitenaf — Ultra Move van binnenuit. Samen het sterkste duo.'};
}
} else if (domain==='sport'&&!step3.find(x=>x.name==='Ultra Move')) {
supp = {name:'Ultra Move',
desc:'Curcumine (95%) als natuurlijke ontstekingsremmer. Vermindert spierpijn en ondersteunt snel herstel. Combineer met een post-training cryo sessie voor het beste resultaat.'};
} else if (domain==='immuunsysteem'&&!step3.find(x=>x.name==='Immuniq-10 Boost')) {
supp = {name:'Immuniq-10 Boost',
desc:'Directe ondersteuning voor energie én weerstand. Cryotherapie traint je immuuncellen — Immuniq-10 Boost geeft ze de voedingsstoffen om optimaal te presteren.'};
} else if (domain==='afslanken') {
const uitdaging = a.v22;
if (['cravings','schommelen'].includes(uitdaging)&&!step3.find(x=>x.name==='GLH-2')) {
supp = {name:'GLH-2',
desc:'GLP-1 booster die cravings en bloedsuikerschommelingen ondersteunt. Minder trek zonder hard je wil te moeten inzetten.'};
} else if (['geen_resultaat','aanmaken'].includes(uitdaging)&&!step3.find(x=>x.name==='Burn Ree Shot')) {
supp = {name:'Burn Ree Shot',
desc:'L-carnitine transporteert vetzuren naar de cel voor energie. Nextida remt de eetlust. Voor serieus afvallen en het verbeteren van de lichaamssamenstelling — de krachtigste optie in dit domein.'};
} else if (!step3.find(x=>x.name==='Fat Burner')) {
supp = {name:'Fat Burner',
desc:'Groene thee-extract activeert het rustmetabolisme en ondersteunt vochtafvoer. Voor gewichtsbeheersing bij een actieve leefstijl. Cryo activeert bruin vet — Fat Burner ondersteunt vetverbranding van binnenuit.'};
}
} else if (domain==='beauty') {
const focus = a.v23;
const huidKlacht = a.v23b;
if (focus==='haar'&&!step3.find(x=>x.name==="Hair Strength+")) {
supp = {name:"Hair Strength+",
desc:'Ondersteunt sterk en gezond haar en draagt bij aan normale haarpigmentatie. Voor zichtbaar verschil in dikte en kwaliteit.'};
} else if (['acne','eczeem','psoriasis','rosacea'].includes(huidKlacht)&&!step3.find(x=>x.name==='Inner Beauty')) {
supp = {name:'Inner Beauty',
desc:'Diepere huidbescherming van binnenuit. Bij onzuiverheden, eczeem of gevoelige huid werkt Inner Beauty op de grondoorzaak: ontsteking en oxidatieve stress.'};
} else if (!step3.find(x=>x.name==='Smart Collagen Shot')) {
supp = {name:'Smart Collagen Shot',
desc:'Keraboost™ voor huid, haar én nagels. Collageenverlies start al op je 25e — dit is onderhoud voor de huid, ook als je nu nog geen klachten hebt. Cryo stimuleert collageenproductie van buitenaf, dit supplement levert de bouwstenen van binnenuit.'};
}
} else if (domain==='spijsvertering'&&!step3.find(x=>x.name==='Symbiotic')) {
supp = {name:'Symbiotic (Gut Day)',
desc:'10 bacteriestammen en 11 spijsverteringsenzymen voor overdag. Ondersteunt een gezonde darmflora en vermindert darmklachten structureel.'};
} else if (domain==='hormonen') {
const age = a.v2;
const meno = a.v3;
if (['45-60','60+'].includes(age)&&meno==='ja'&&!step3.find(x=>x.name==='Meno Comfort')) {
supp = {name:'Meno Comfort',
desc:'Gericht op vrouwelijk welzijn tijdens hormonale veranderingen, ook voor soepele gewrichten en slaapkwaliteit.'};
} else if (!step3.find(x=>x.name==='Balance Me')) {
supp = {name:'Balance Me',
desc:'Ondersteunt hormonale balans en helpt stress en vermoeidheid te verminderen. Voor vrouwen die willen bijsturen zonder grote ingrepen.'};
}
} else if (domain==='energie'&&score>=5) {
if (s.immuunsysteem>=2&&!step3.find(x=>x.name==='Immuniq-10 Boost')) {
supp = {name:'Immuniq-10 Boost',
desc:'Lage energie en een zwakker immuunsysteem gaan vaak hand in hand. Ondersteunt beide tegelijk.'};
} else if (!step3.find(x=>x.name==='Mental Boost')) {
supp = {name:'Mental Boost',
desc:'Als vermoeidheid ook je hoofd raakt — focus en stemming — werkt Mental Boost op precies die plek.'};
}
}
if (supp&&!step3.find(x=>x.name===supp.name)) step3.push(supp);
}
if (step3.length===0) {
step3.push({name:'Immuniq-10 Boost',
desc:'Preventieve ondersteuning voor energie en weerstand. Een goed startpunt als basis voor langetermijn gezondheid.'});
}
}
step3.forEach((item,i)=>supps.push({
step: step3.length>1?'Stap 3 — Persoonlijke nood '+(i+1):'Stap 3 — Persoonlijke nood',
...item
}));
return supps;
}
function showResults() {
document.getElementById('quiz-screen').style.display='none';
const rs=document.getElementById('results-screen');
rs.style.display='flex'; rs.style.flexDirection='column';
const pid   = computeProfile();
const prof  = PROFILES[pid];
const supps = computeSupplements();
document.getElementById('res-name').textContent    = prof.name;
document.getElementById('res-tagline').textContent = prof.tagline;
document.getElementById('res-desc').textContent    = prof.desc;
document.getElementById('cryo-freq').textContent   = prof.cryoFreq;
document.getElementById('cryo-text').textContent   = prof.cryoText;
document.getElementById('supps-list').innerHTML = supps.map(s=>`
<div class="supp-card">
<div class="supp-step">${s.step}</div>
<div class="supp-name">${s.name}</div>
<div class="supp-desc">${s.desc}</div>
${s.note?'<div class="supp-note">'+s.note+'</div>':''}
</div>`).join('');
const s3 = supps.filter(s=>s.step.startsWith('Stap 3'));
document.getElementById('behandelplan-wrap').innerHTML = s3.length>=2?`
<div class="behandelplan">
<div class="behandelplan-title">Opbouwstrategie</div>
<p>We bouwen bewust op. Start met stap 1 en 2 plus het eerste stap 3-product de eerste 3 maanden. Evalueer daarna en voeg toe. Stap voor stap werkt beter dan alles tegelijk — je lichaam heeft tijd nodig om te reageren.</p>
</div>`:'';
document.getElementById('instant-tip').style.display='block';
const preview=supps.map(s=>s.name).join(', ');
document.getElementById('res-supp-preview').innerHTML=
'<strong style="color:var(--frs-blue);font-size:11px;letter-spacing:1px;text-transform:uppercase">Jouw supplementen:</strong><br>'+preview;
if (state.answers.email_addr) document.getElementById('res-email-res').value=state.answers.email_addr;
if (state.answers.email_name) document.getElementById('res-naam').value=state.answers.email_name;
sendToSheets(pid,supps);
}
function toggleReservation() {
document.getElementById('reservation-form').classList.toggle('open');
}
function submitReservation() {
const n=document.getElementById('res-naam').value.trim();
const e=document.getElementById('res-email-res').value.trim();
if (!n||!e.includes('@')){alert('Vul je naam en e-mailadres in.');return;}
document.getElementById('reservation-form').style.display='none';
document.getElementById('reservation-confirm').style.display='block';
}
function sendToSheets(pid,supps) {
const URL='';
if (!URL) return;
fetch(URL,{method:'POST',mode:'no-cors',headers:{'Content-Type':'application/json'},
body:JSON.stringify({naam:state.answers.email_name||'',email:state.answers.email_addr||'',
newsletter:state.answers.newsletter||false,geslacht:state.answers.v1||'',
leeftijd:state.answers.v2||'',profiel:pid,supplementen:supps.map(s=>s.name).join(' | '),
scores:JSON.stringify(state.scores),datum:new Date().toISOString()})
}).catch(()=>{});
}